import * as  React from 'react';
import { GitView, CheckoutView, SyncView } from '@git-stack/client-react';
import {reducers} from '@git-stack/client-redux';

import { Feature } from '@common-stack/client-react';

export default new Feature({
  leftMainPanelItems: { git: <GitView /> },
  reducer: { ...reducers },
  leftFooterItems: [(<CheckoutView />), (<SyncView />)],
} as any);
